import * as React from 'react';
import * as ReactDOM from 'react-dom';


import {
  Button,
  ButtonGroup,
  SplitButton,
  Toolbar,
  ToolbarItem,
  ToolbarSeparator,
  ToolbarSpacer,
} from '@progress/kendo-react-buttons';
import { Icon } from '@progress/kendo-react-common';
import { ColorPicker, Signature } from '@progress/kendo-react-inputs';
import { loadMessages, LocalizationProvider } from '@progress/kendo-react-intl';



const paletteSettings = {
  palette: [
    '#ffffff',
    '#000000',
    '#dae2f4',
    '#435669',
    '#4471c5',
    '#ed7e33',
    '#a5a4a5',
    '#ffbf06',
    '#5a9bd5',
    '#71ae48'

  ],
  columns: 5,
  tileSize: 22,
};


const SignatureKendoRct = (props:SignatureKendoProps) => {
  const {
    value, onSigChange
  }=props;
  const [color, setColor] = React.useState();
  const [strokeWidth, setStrokeWidth] = React.useState(1);
  const [imageURL, setImageURL] = React.useState();

  const onColorChange = (e:any) => {
    setColor(e.value);
  };

  const revokeImageURL = () => {
    if (imageURL) {
      URL.revokeObjectURL(imageURL);
      setImageURL(undefined);
    }
  };



  // Clean up on unmount.
  React.useEffect(() => revokeImageURL, []);



  return (
    <div className="example">
      <div className="content-wrapper client-sign-box">
       
        <div className="signature-wrapper signBorder position-relative">

          <Signature
            value={value}
            onChange={onSigChange}
              color={color}
              strokeWidth={strokeWidth}
              smooth={true}
              maximizable={false}
              hideLine={true}
            
          />


        </div>
      </div>
    </div>
  );
};;

export default SignatureKendoRct;


export interface SignatureKendoProps{
  value:any, onSigChange:any
}
